/* =========================================================
   Diesel PDP "select a size" gate — matches uk.diesel.com.

   No size is pre-selected on load (done in Liquid — product-variant-options
   suppresses the default for size-like options with >1 value). This script:
   - blocks Add to Bag while a required size option is unselected, and instead
     shakes the size grid + shows a "Please select <Option>" message (exactly
     like Diesel: 0.6s ease-in-out shake, red message bar);
   - clears that error the moment the shopper picks a value;
   - replays the shake on repeat clicks;
   - clears any stale variant id from the form so nothing can be added blind.

   Everything is delegated on document, so it keeps working after the colour
   swap replaces <product-info> (the swapped-in form has no size selected too).
   ========================================================= */
(function () {
  'use strict';

  var SHAKE_MS = 600;

  // The variant-selects fieldsets that must be chosen before adding. Colour is
  // handled by sibling products, so every rendered option here is a size axis;
  // still, a fieldset counts as "required" only when it has >1 option so a
  // one-size product (single value) never blocks.
  function requiredFieldsets(productInfo) {
    var out = [];
    var sets = productInfo.querySelectorAll('variant-selects fieldset');
    Array.prototype.forEach.call(sets, function (fs) {
      var inputs = fs.querySelectorAll('input[type="radio"], select');
      var optionCount = fs.querySelectorAll('input[type="radio"]').length;
      if (!optionCount) {
        // dropdown variant
        var sel = fs.querySelector('select');
        optionCount = sel ? sel.options.length : 0;
      }
      if (optionCount > 1) out.push(fs);
    });
    return out;
  }

  function isChosen(fieldset) {
    if (fieldset.querySelector('input[type="radio"]:checked')) return true;
    var sel = fieldset.querySelector('select');
    if (sel && sel.value && sel.selectedOptions && sel.selectedOptions.length) {
      // a select always has a value; treat it as chosen only if an option is
      // explicitly marked selected (Liquid clears that for size).
      return !!fieldset.querySelector('select option[selected]');
    }
    return false;
  }

  function optionLabel(fieldset) {
    var legend = fieldset.querySelector('legend, .form__label');
    var txt = legend ? legend.textContent : '';
    // strip trailing helper text like "Size chart"
    txt = (txt || '').replace(/size chart/i, '').replace(/\s+/g, ' ').trim();
    return txt || 'a size';
  }

  function messageFor(fieldset) {
    var label = optionLabel(fieldset);
    // "Please select Size" (matches Diesel's per-axis wording).
    return 'Please select ' + label;
  }

  function ensureMessage(fieldset) {
    var msg = fieldset.querySelector('.dsl-size-error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'dsl-size-error';
      msg.setAttribute('role', 'alert');
      msg.innerHTML =
        '<svg class="dsl-size-error__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
        '<path d="M12 3l9 16H3L12 3z" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linejoin="round"/>' +
        '<path d="M12 10v4" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
        '<circle cx="12" cy="17" r="1" fill="currentColor"/></svg>' +
        '<span class="dsl-size-error__text"></span>';
      fieldset.appendChild(msg);
    }
    msg.querySelector('.dsl-size-error__text').textContent = messageFor(fieldset);
    return msg;
  }

  function flagInvalid(fieldset) {
    ensureMessage(fieldset);
    fieldset.classList.add('dsl-size-invalid');
    // restart the shake even on repeat clicks
    fieldset.classList.remove('dsl-size-shake');
    void fieldset.offsetWidth; // reflow
    fieldset.classList.add('dsl-size-shake');
  }

  function clearInvalid(fieldset) {
    fieldset.classList.remove('dsl-size-invalid', 'dsl-size-shake');
    var msg = fieldset.querySelector('.dsl-size-error');
    if (msg) msg.remove();
  }

  // NOTE: the size is deselected at the SOURCE so it never paints selected (no
  // flash) — the parser-blocking inline script in product-variant-picker.liquid
  // handles initial load, and color-swatch-swap.js strips the default from the
  // swapped-in colour. This file only enforces the gate below.

  // Intercept Add to Bag in the CAPTURE phase so we run before Dawn's
  // ProductForm submit handler and can stop it.
  document.addEventListener(
    'submit',
    function (e) {
      var form = e.target;
      if (!form || !form.closest) return;
      var productForm = form.closest('product-form');
      var productInfo = form.closest('product-info');
      if (!productForm || !productInfo) return;

      var unmet = requiredFieldsets(productInfo).filter(function (fs) {
        return !isChosen(fs);
      });
      if (unmet.length) {
        e.preventDefault();
        e.stopImmediatePropagation(); // block Dawn's add
        unmet.forEach(flagInvalid);
        unmet[0].scrollIntoView({ block: 'center', behavior: 'smooth' });
      }
    },
    true
  );

  // Selecting a value clears that option's error immediately.
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var fs = t.closest('variant-selects fieldset');
    if (fs) clearInvalid(fs);
  });

  // Also drop the shake class when its animation ends, so it can replay.
  document.addEventListener(
    'animationend',
    function (e) {
      if (e.animationName === 'dsl-size-shake' && e.target.classList) {
        e.target.classList.remove('dsl-size-shake');
      }
    },
    true
  );

})();
